import React, { useState } from 'react';
import { adminProductApi } from '../../../../api/adminProductApi';
import { prepareImagesForUpload } from '../../../../utils/imageUploadUtils';
import MobileProductField from './MobileProductField';
import MobileProductHint from './MobileProductHint';
import { productImageUrl } from './mobileProductUtils';

export default function MobileProductImages({ draft, onChange, mutation }) {
  const [url, setUrl] = useState('');
  const [removing, setRemoving] = useState(null);
  const append = response => {
    const added = response.data?.data?.uploadedImagesNames;
    if (!Array.isArray(added)) throw new Error('Сервер не повернув список збережених фото');
    onChange([...draft.images, ...added], { added });
  };
  const upload = files =>
    mutation.run(async () => {
      const prepared = await prepareImagesForUpload(files, {
        onlyMobile: true,
        maxWidth: 1920,
        maxHeight: 1920,
        quality: 0.82,
        minBytes: 700 * 1024,
      });
      const data = new FormData();
      prepared.forEach(file => data.append('images', file));
      return adminProductApi.uploadProductImages(draft.id, data);
    }, append);
  const reorder = (index, step) => {
    const images = [...draft.images];
    [images[index], images[index + step]] = [images[index + step], images[index]];
    onChange(images);
  };
  if (!draft.id)
    return (
      <MobileProductHint>
        Спочатку збережіть товар, після цього можна додати фото.
      </MobileProductHint>
    );
  return (
    <section className='mp-images'>
      <MobileProductHint>
        Додавання та видалення фото зберігаються одразу. Порядок фото збережеться разом із товаром.
      </MobileProductHint>
      <label className='mp-field'>
        <span>Додати фото</span>
        <input
          type='file'
          accept='image/*'
          multiple
          disabled={mutation.busy}
          onChange={event => {
            const files = Array.from(event.target.files || []);
            event.target.value = '';
            if (files.length) upload(files);
          }}
        />
      </label>
      <MobileProductField
        label='Сторінка виробника з фото'
        type='url'
        value={url}
        disabled={mutation.busy}
        onChange={setUrl}
      />
      <button
        type='button'
        className='btn btn-outline-secondary'
        disabled={mutation.busy || !url.trim()}
        onClick={() => {
          if (!/^https?:\/\//i.test(url.trim())) {
            mutation.setError('Вкажіть посилання, що починається з https:// або http://');
            return;
          }
          mutation.run(
            () =>
              adminProductApi.parseProductImages(draft.id, url.trim()),
            append,
          );
        }}
      >
        Завантажити зі сторінки
      </button>
      {draft.images.map((image, index) => (
        <div className='mp-image-row' key={`${image}-${index}`}>
          <img src={productImageUrl(image)} alt={`Фото товару ${index + 1}`} />
          <div>
            <strong>Фото {index + 1}</strong>
            <div className='mp-inline-actions'>
              <button
                type='button'
                className='btn btn-outline-secondary'
                aria-label={`Перемістити фото ${index + 1} вище`}
                disabled={mutation.busy || index === 0}
                onClick={() => reorder(index, -1)}
              >
                ↑
              </button>
              <button
                type='button'
                className='btn btn-outline-secondary'
                aria-label={`Перемістити фото ${index + 1} нижче`}
                disabled={mutation.busy || index === draft.images.length - 1}
                onClick={() => reorder(index, 1)}
              >
                ↓
              </button>
              <button
                type='button'
                className='btn btn-outline-danger'
                disabled={mutation.busy}
                onClick={() => setRemoving(image)}
              >
                Видалити
              </button>
            </div>
          </div>
        </div>
      ))}
      {removing && (
        <div className='mp-feedback mp-feedback-error' role='alert'>
          <p>Видалити це фото?</p>
          <div className='mp-inline-actions'>
            <button
              type='button'
              className='btn btn-danger'
              disabled={mutation.busy}
              onClick={() =>
                mutation.run(
                  () =>
                    adminProductApi.deleteProductImage(draft.id, removing),
                  () => {
                    onChange(
                      draft.images.filter(image => image !== removing),
                      { removed: removing },
                    );
                    setRemoving(null);
                  },
                )
              }
            >
              Видалити фото
            </button>
            <button
              type='button'
              className='btn btn-outline-secondary'
              disabled={mutation.busy}
              onClick={() => setRemoving(null)}
            >
              Скасувати
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
